"use client";

import { useMotionValueEvent, useScroll } from "motion/react";
import * as motion from "motion/react-m";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

import { AdarshMark } from "./adarsh-mark";

export function SiteHeaderMark({
  className = "h-4 w-auto sm:h-5",
}: {
  className?: string;
}) {
  const pathname = usePathname();
  return pathname === "/" ? (
    <AdarshMarkMotion className={className} />
  ) : (
    <AdarshMark className={className} />
  );
}

function AdarshMarkMotion({ className }: { className?: string }) {
  const { scrollY } = useScroll();
  const [visible, setVisible] = useState(false);
  const distanceRef = useRef(160);

  useMotionValueEvent(scrollY, "change", (latestValue) => {
    setVisible(latestValue >= distanceRef.current);
  });

  useEffect(() => {
    const coverMark = document.getElementById("js-cover-mark");
    if (!coverMark) return;

    distanceRef.current = calcDistance(coverMark);

    const resizeObserver = new ResizeObserver(() => {
      distanceRef.current = calcDistance(coverMark);
    });
    resizeObserver.observe(coverMark);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  // Replace the SVG below with your logo's SVG path!
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 310 70"
      className={className}
      initial={{
        opacity: 0,
        transform: "translateY(8px)",
      }}
      animate={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0px)" : "translateY(8px)",
      }}
      transition={{ duration: 0.3 }}
    >
      <path
        fill="currentColor"
        d="M10 0h10v10h-10zM20 0h10v10h-10zM30 0h10v10h-10zM0 10h10v10h-10zM40 10h10v10h-10zM0 20h10v10h-10zM40 20h10v10h-10zM0 30h10v10h-10zM10 30h10v10h-10zM20 30h10v10h-10zM30 30h10v10h-10zM40 30h10v10h-10zM0 40h10v10h-10zM40 40h10v10h-10zM0 50h10v10h-10zM40 50h10v10h-10zM0 60h10v10h-10zM40 60h10v10h-10zM52 0h10v10h-10zM62 0h10v10h-10zM72 0h10v10h-10zM82 0h10v10h-10zM52 10h10v10h-10zM92 10h10v10h-10zM52 20h10v10h-10zM92 20h10v10h-10zM52 30h10v10h-10zM92 30h10v10h-10zM52 40h10v10h-10zM92 40h10v10h-10zM52 50h10v10h-10zM92 50h10v10h-10zM52 60h10v10h-10zM62 60h10v10h-10zM72 60h10v10h-10zM82 60h10v10h-10zM114 0h10v10h-10zM124 0h10v10h-10zM134 0h10v10h-10zM104 10h10v10h-10zM144 10h10v10h-10zM104 20h10v10h-10zM144 20h10v10h-10zM104 30h10v10h-10zM114 30h10v10h-10zM124 30h10v10h-10zM134 30h10v10h-10zM144 30h10v10h-10zM104 40h10v10h-10zM144 40h10v10h-10zM104 50h10v10h-10zM144 50h10v10h-10zM104 60h10v10h-10zM144 60h10v10h-10zM156 0h10v10h-10zM166 0h10v10h-10zM176 0h10v10h-10zM186 0h10v10h-10zM156 10h10v10h-10zM196 10h10v10h-10zM156 20h10v10h-10zM196 20h10v10h-10zM156 30h10v10h-10zM166 30h10v10h-10zM176 30h10v10h-10zM186 30h10v10h-10zM156 40h10v10h-10zM176 40h10v10h-10zM156 50h10v10h-10zM186 50h10v10h-10zM156 60h10v10h-10zM196 60h10v10h-10zM218 0h10v10h-10zM228 0h10v10h-10zM238 0h10v10h-10zM248 0h10v10h-10zM208 10h10v10h-10zM208 20h10v10h-10zM218 30h10v10h-10zM228 30h10v10h-10zM238 30h10v10h-10zM248 40h10v10h-10zM248 50h10v10h-10zM208 60h10v10h-10zM218 60h10v10h-10zM228 60h10v10h-10zM238 60h10v10h-10zM260 0h10v10h-10zM300 0h10v10h-10zM260 10h10v10h-10zM300 10h10v10h-10zM260 20h10v10h-10zM300 20h10v10h-10zM260 30h10v10h-10zM270 30h10v10h-10zM280 30h10v10h-10zM290 30h10v10h-10zM300 30h10v10h-10zM260 40h10v10h-10zM300 40h10v10h-10zM260 50h10v10h-10zM300 50h10v10h-10zM260 60h10v10h-10zM300 60h10v10h-10z"
      />
    </motion.svg>
  );
}

const calcDistance = (el: HTMLElement) => {
  const rect = el.getBoundingClientRect();
  const scrollTop = document.documentElement.scrollTop;
  const headerHeight = 56;
  return scrollTop + rect.top + rect.height - headerHeight;
};
